import { render, staticRenderFns } from "./WSwitch.vue?vue&type=template&id=3fc1f032&"
import script from "./WSwitch.vue?vue&type=script&lang=js&"
export * from "./WSwitch.vue?vue&type=script&lang=js&"
import style0 from "./WSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports